import React, { useContext } from 'react';
import AppContext from 'app/AppContext';
import { LegendDataItem } from './portfolioReturnsLegendsData';
import './PortfolioReturnsLegends.scss';
import classnames from 'classnames';
import { BooleanKeys } from 'utils/types/BooleanKeys';
import { WidgetLegend } from 'widgets/WidgetLegend/WidgetLegend';
import {
    PortfolioReturnsConfigurationState,
    PortfolioReturnsWidgetLegends,
} from 'widgets/portfolioReturns/store/configuration/PortfolioReturnsConfigurationState';
import { useToggleConfigOption } from 'widgets/store/configuration/hooks';

interface PortfolioReturnsLegendProps {
    alignDropdown?: 'left' | 'center' | 'right';
    label: string;
    value?: LegendDataItem;
    className?: string;
    hideValueChange?: boolean;
    hideSeriesPropertyName: BooleanKeys<PortfolioReturnsWidgetLegends>;
}

export default function PortfolioReturnsLegend(
    props: PortfolioReturnsLegendProps
) {
    const {
        alignDropdown,
        label,
        value,
        className,
        hideSeriesPropertyName,
        hideValueChange,
    } = props;

    const { numberFormat, currencyFormat } = useContext(AppContext);

    const { value: seriesHidden, toggle: toggleSeriesHidden } =
        useToggleConfigOption<PortfolioReturnsConfigurationState>(
            hideSeriesPropertyName
        );

    const valueDisplay = seriesHidden
        ? ''
        : value === undefined
        ? '-'
        : `${numberFormat.n0(value.bps)}bps`;

    const valueChangeDisplay =
        seriesHidden || value === undefined
            ? ''
            : currencyFormat.c0FmtFxWithPrefix(value.valueChange ?? 0);

    const legendClassName = hideSeriesPropertyName?.substring(4).toLowerCase();

    const hideLegendPropertyName =
        `${hideSeriesPropertyName}Legend` as BooleanKeys<PortfolioReturnsConfigurationState>;

    return (
        <WidgetLegend<PortfolioReturnsConfigurationState>
            alignDropdown={alignDropdown}
            hideLegendPropertyName={hideLegendPropertyName}
            showSeries={!seriesHidden}
            toggleShowSeries={toggleSeriesHidden}
        >
            <div
                className={classnames(
                    'PortfolioReturnsLegend',
                    'Legend',
                    className,
                    seriesHidden && 'not-displayed',
                    legendClassName
                )}
                onClick={toggleSeriesHidden}
            >
                <div className="title-row">
                    <span className="label">{label}</span>
                    <span className="bps value">{valueDisplay}</span>
                </div>
                {!hideValueChange && (
                    <div className="value-change-row">
                        <span className="value">{valueChangeDisplay}</span>
                    </div>
                )}
            </div>
        </WidgetLegend>
    );
}
